import { render, staticRenderFns } from "./SmartTableRowActions.vue?vue&type=template&id=88c2c9be&"
import script from "./SmartTableRowActions.vue?vue&type=script&lang=js&"
export * from "./SmartTableRowActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports